const InventoryIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={30}
      height={30}
      viewBox="0 0 30 30"
    >
      {/* Clipboard top */}
      <rect x="9" y="2" width="12" height="5" rx="1.5" fill="#707070" />

      {/* Clipboard body */}
      <rect
        x="5"
        y="5"
        width="20"
        height="23"
        rx="2"
        fill="none"
        stroke="#707070"
        strokeWidth="2"
      />

      {/* Text lines */}
      <rect x="8" y="10" width="14" height="2" fill="#707070" />
      <rect x="8" y="14" width="14" height="2" fill="#707070" />
      <rect x="8" y="18" width="8" height="2" fill="#707070" />
    </svg>
  )
}

export default InventoryIcon
